import _taggedTemplateLiteral from "/Users/raunaqsingh/Developer/projects.34st.com/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import "core-js/modules/esnext.global-this.js";
import * as e from "react";
import t, { useState as n, useMemo as r, forwardRef as i, useContext as o, createElement as a, createContext as s, Fragment as l, useRef as c, useLayoutEffect as u, useEffect as d, useCallback as f } from "react";
import m from "react-dom";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
!function () {
  function e(e) {
    var t = !0,
        n = !1,
        r = null,
        i = {
      text: !0,
      search: !0,
      url: !0,
      tel: !0,
      email: !0,
      password: !0,
      number: !0,
      date: !0,
      month: !0,
      week: !0,
      time: !0,
      datetime: !0,
      "datetime-local": !0
    };

    function o(e) {
      return !!(e && e !== document && "HTML" !== e.nodeName && "BODY" !== e.nodeName && "classList" in e && "contains" in e.classList);
    }

    function a(e) {
      var t = e.type,
          n = e.tagName;
      return !("INPUT" !== n || !i[t] || e.readOnly) || "TEXTAREA" === n && !e.readOnly || !!e.isContentEditable;
    }

    function s(e) {
      e.classList.contains("focus-visible") || (e.classList.add("focus-visible"), e.setAttribute("data-focus-visible-added", ""));
    }

    function l(e) {
      e.hasAttribute("data-focus-visible-added") && (e.classList.remove("focus-visible"), e.removeAttribute("data-focus-visible-added"));
    }

    function c(n) {
      n.metaKey || n.altKey || n.ctrlKey || (o(e.activeElement) && s(e.activeElement), t = !0);
    }

    function u(e) {
      t = !1;
    }

    function d(e) {
      o(e.target) && (t || a(e.target)) && s(e.target);
    }

    function f(e) {
      o(e.target) && (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) && (n = !0, window.clearTimeout(r), r = window.setTimeout(function () {
        n = !1;
      }, 100), l(e.target));
    }

    function m(e) {
      "hidden" === document.visibilityState && (n && (t = !0), p());
    }

    function p() {
      document.addEventListener("mousemove", g), document.addEventListener("mousedown", g), document.addEventListener("mouseup", g), document.addEventListener("pointermove", g), document.addEventListener("pointerdown", g), document.addEventListener("pointerup", g), document.addEventListener("touchmove", g), document.addEventListener("touchstart", g), document.addEventListener("touchend", g);
    }

    function h() {
      document.removeEventListener("mousemove", g), document.removeEventListener("mousedown", g), document.removeEventListener("mouseup", g), document.removeEventListener("pointermove", g), document.removeEventListener("pointerdown", g), document.removeEventListener("pointerup", g), document.removeEventListener("touchmove", g), document.removeEventListener("touchstart", g), document.removeEventListener("touchend", g);
    }

    function g(e) {
      e.target.nodeName && "html" === e.target.nodeName.toLowerCase() || (t = !1, h());
    }

    document.addEventListener("keydown", c, !0), document.addEventListener("mousedown", u, !0), document.addEventListener("pointerdown", u, !0), document.addEventListener("touchstart", u, !0), document.addEventListener("visibilitychange", m, !0), p(), e.addEventListener("focus", d, !0), e.addEventListener("blur", f, !0), e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.host ? e.host.setAttribute("data-js-focus-visible", "") : e.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
  }

  if ("undefined" != typeof window && "undefined" != typeof document) {
    var t;
    window.applyFocusVisiblePolyfill = e;

    try {
      t = new CustomEvent("focus-visible-polyfill-ready");
    } catch (e) {
      (t = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
    }

    window.dispatchEvent(t);
  }

  "undefined" != typeof document && e(document);
}();

var p = t.createContext({}),
    h = function h(e) {
  var n = Object.assign({}, {
    cardHeight: 200,
    useReadMore: !0,
    borderLessCards: !1,
    timelineCircleDimension: 16,
    lineWidth: 3,
    disableClickOnCircle: !1,
    disableAutoScrollOnClick: !1,
    scrollable: {
      scrollbar: !1
    }
  }, e),
      r = e.children;
  return t.createElement(p.Provider, {
    value: n
  }, r);
},
    g = function g(e, t) {
  var i = n(0),
      o = i[0],
      a = i[1];
  return [o, r(function () {
    return function (n, r) {
      var i = n.clientWidth,
          o = n.scrollLeft,
          s = n.scrollTop,
          l = n.clientHeight,
          c = r.pointOffset,
          u = r.pointWidth,
          d = r.contentHeight,
          f = r.contentOffset;
      if (c) if ("HORIZONTAL" === e && t && u) {
        var m = o + i,
            p = c + u,
            h = c - o,
            g = m - c;
        c >= o && p <= m || c < o && p > o || p > m && c < m ? (h <= t && h >= 0 || g <= t && g >= 0) && a(c - t) : a(c - t);
      } else if ("VERTICAL" === e || "VERTICAL_ALTERNATING" === e) {
        if (!f || !d) return;
        var v = s + l,
            y = f + d,
            b = f - d,
            E = !(f >= s && y <= v) || f < s && y > s || y > v && f < v;
        E && b + d < v ? a(b + Math.round(d / 2)) : E && a(b);
      }
    };
  }, [e, t])];
},
    v = function v() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-left"
  }, t.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
},
    y = function y() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-right"
  }, t.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
},
    b = function b() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-left"
  }, t.createElement("polyline", {
    points: "11 17 6 12 11 7"
  }), t.createElement("polyline", {
    points: "18 17 13 12 18 7"
  }));
},
    E = function E() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-right"
  }, t.createElement("polyline", {
    points: "13 17 18 12 13 7"
  }), t.createElement("polyline", {
    points: "6 17 11 12 6 7"
  }));
},
    w = function w() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, t.createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};

function N() {
  return N = Object.assign || function (e) {
    for (var t = arguments, n = 1; n < arguments.length; n++) {
      var r = t[n];

      for (var i in r) {
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
      }
    }

    return e;
  }, N.apply(this, arguments);
}

function x(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}

var k = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    O = x(function (e) {
  return k.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
});

var C = function () {
  function e(e) {
    var t = this;
    this._insertTag = function (e) {
      var n;
      n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
    }, this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
  }

  var t = e.prototype;
  return t.hydrate = function (e) {
    e.forEach(this._insertTag);
  }, t.insert = function (e) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
      var t = document.createElement("style");
      return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
    }(this));
    var t = this.tags[this.tags.length - 1];

    if ("production" !== process.env.NODE_ENV) {
      var n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1);
      n && this._alreadyInsertedOrderInsensitiveRule, this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n;
    }

    if (this.isSpeedy) {
      var r = function (e) {
        if (e.sheet) return e.sheet;

        for (var t = 0; t < document.styleSheets.length; t++) {
          if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
        }
      }(t);

      try {
        r.insertRule(e, r.cssRules.length);
      } catch (t) {
        "production" !== process.env.NODE_ENV && /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(e);
      }
    } else t.appendChild(document.createTextNode(e));

    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode && e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0, "production" !== process.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(),
    _ = "-ms-",
    S = "-moz-",
    T = "-webkit-",
    A = Math.abs,
    L = String.fromCharCode,
    D = Object.assign;

function V(e) {
  return e.trim();
}

function I(e, t, n) {
  return e.replace(t, n);
}

function j(e, t) {
  return e.indexOf(t);
}

function R(e, t) {
  return 0 | e.charCodeAt(t);
}

function $(e, t, n) {
  return e.slice(t, n);
}

function M(e) {
  return e.length;
}

function P(e) {
  return e.length;
}

function z(e, t) {
  return t.push(e), e;
}

var W = 1,
    H = 1,
    F = 0,
    q = 0,
    B = 0,
    U = "";

function Y(e, t, n, r, i, o, a) {
  return {
    value: e,
    root: t,
    parent: n,
    type: r,
    props: i,
    children: o,
    line: W,
    column: H,
    length: a,
    return: ""
  };
}

function G(e, t) {
  return D(Y("", null, null, "", null, null, 0), e, {
    length: -e.length
  }, t);
}

function Z() {
  return B = q > 0 ? R(U, --q) : 0, H--, 10 === B && (H = 1, W--), B;
}

function X() {
  return B = q < F ? R(U, q++) : 0, H++, 10 === B && (H = 1, W++), B;
}

function K() {
  return R(U, q);
}

function J() {
  return q;
}

function Q(e, t) {
  return $(U, e, t);
}

function ee(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function te(e) {
  return W = H = 1, F = M(U = e), q = 0, [];
}

function ne(e) {
  return U = "", e;
}

function re(e) {
  return V(Q(q - 1, ae(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
}

function ie(e) {
  for (; (B = K()) && B < 33;) {
    X();
  }

  return ee(e) > 2 || ee(B) > 3 ? "" : " ";
}

function oe(e, t) {
  for (; --t && X() && !(B < 48 || B > 102 || B > 57 && B < 65 || B > 70 && B < 97);) {
    ;
  }

  return Q(e, J() + (t < 6 && 32 == K() && 32 == X()));
}

function ae(e) {
  for (; X();) {
    switch (B) {
      case e:
        return q;

      case 34:
      case 39:
        34 !== e && 39 !== e && ae(B);
        break;

      case 40:
        41 === e && ae(e);
        break;

      case 92:
        X();
    }
  }

  return q;
}

function se(e, t) {
  for (; X() && e + B !== 57 && (e + B !== 84 || 47 !== K());) {
    ;
  }

  return "/*" + Q(t, q - 1) + "*" + L(47 === e ? e : X());
}

function le(e) {
  for (; !ee(K());) {
    X();
  }

  return Q(e, q);
}

function ce(e) {
  return ne(ue("", null, null, null, [""], e = te(e), 0, [0], e));
}

function ue(e, t, n, r, i, o, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, m = 0, p = 0, h = 1, g = 1, v = 1, y = 0, b = "", E = i, w = o, N = r, x = b; g;) {
    switch (p = y, y = X()) {
      case 40:
        if (108 != p && 58 == x.charCodeAt(d - 1)) {
          -1 != j(x += I(re(y), "&", "&\f"), "&\f") && (v = -1);
          break;
        }

      case 34:
      case 39:
      case 91:
        x += re(y);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        x += ie(p);
        break;

      case 92:
        x += oe(J() - 1, 7);
        continue;

      case 47:
        switch (K()) {
          case 42:
          case 47:
            z(fe(se(X(), J()), t, n), l);
            break;

          default:
            x += "/";
        }

        break;

      case 123 * h:
        s[c++] = M(x) * v;

      case 125 * h:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            g = 0;

          case 59 + u:
            m > 0 && M(x) - d && z(m > 32 ? me(x + ";", r, n, d - 1) : me(I(x, " ", "") + ";", r, n, d - 2), l);
            break;

          case 59:
            x += ";";

          default:
            if (z(N = de(x, t, n, c, u, i, s, b, E = [], w = [], d), o), 123 === y) if (0 === u) ue(x, t, N, N, E, o, d, s, w);else switch (f) {
              case 100:
              case 109:
              case 115:
                ue(e, N, N, r && z(de(e, N, N, 0, 0, i, s, b, i, E = [], d), w), i, w, d, s, r ? E : w);
                break;

              default:
                ue(x, N, N, N, [""], w, 0, s, w);
            }
        }

        c = u = m = 0, h = v = 1, b = x = "", d = a;
        break;

      case 58:
        d = 1 + M(x), m = p;

      default:
        if (h < 1) if (123 == y) --h;else if (125 == y && 0 == h++ && 125 == Z()) continue;

        switch (x += L(y), y * h) {
          case 38:
            v = u > 0 ? 1 : (x += "\f", -1);
            break;

          case 44:
            s[c++] = (M(x) - 1) * v, v = 1;
            break;

          case 64:
            45 === K() && (x += re(X())), f = K(), u = d = M(b = x += le(J())), y++;
            break;

          case 45:
            45 === p && 2 == M(x) && (h = 0);
        }

    }
  }

  return o;
}

function de(e, t, n, r, i, o, a, s, l, c, u) {
  for (var d = i - 1, f = 0 === i ? o : [""], m = P(f), p = 0, h = 0, g = 0; p < r; ++p) {
    for (var v = 0, y = $(e, d + 1, d = A(h = a[p])), b = e; v < m; ++v) {
      (b = V(h > 0 ? f[v] + " " + y : I(y, /&\f/g, f[v]))) && (l[g++] = b);
    }
  }

  return Y(e, t, n, 0 === i ? "rule" : s, l, c, u);
}

function fe(e, t, n) {
  return Y(e, t, n, "comm", L(B), $(e, 2, -2), 0);
}

function me(e, t, n, r) {
  return Y(e, t, n, "decl", $(e, 0, r), $(e, r + 1, -1), r);
}

function pe(e, t) {
  switch (function (e, t) {
    return (((t << 2 ^ R(e, 0)) << 2 ^ R(e, 1)) << 2 ^ R(e, 2)) << 2 ^ R(e, 3);
  }(e, t)) {
    case 5103:
      return T + "print-" + e + e;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + S + e + _ + e + e;

    case 6828:
    case 4268:
      return T + e + _ + e + e;

    case 6165:
      return T + e + _ + "flex-" + e + e;

    case 5187:
      return T + e + I(e, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + e;

    case 5443:
      return T + e + _ + "flex-item-" + I(e, /flex-|-self/, "") + e;

    case 4675:
      return T + e + _ + "flex-line-pack" + I(e, /align-content|flex-|-self/, "") + e;

    case 5548:
      return T + e + _ + I(e, "shrink", "negative") + e;

    case 5292:
      return T + e + _ + I(e, "basis", "preferred-size") + e;

    case 6060:
      return T + "box-" + I(e, "-grow", "") + T + e + _ + I(e, "grow", "positive") + e;

    case 4554:
      return T + I(e, /([^-])(transform)/g, "$1-webkit-$2") + e;

    case 6187:
      return I(I(I(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;

    case 5495:
    case 3959:
      return I(e, /(image-set\([^]*)/, T + "$1$`$1");

    case 4968:
      return I(I(e, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return I(e, /(.+)-inline(.+)/, T + "$1$2") + e;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (M(e) - 1 - t > 6) switch (R(e, t + 1)) {
        case 109:
          if (45 !== R(e, t + 4)) break;

        case 102:
          return I(e, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + S + (108 == R(e, t + 3) ? "$3" : "$2-$3")) + e;

        case 115:
          return ~j(e, "stretch") ? pe(I(e, "stretch", "fill-available"), t) + e : e;
      }
      break;

    case 4949:
      if (115 !== R(e, t + 1)) break;

    case 6444:
      switch (R(e, M(e) - 3 - (~j(e, "!important") && 10))) {
        case 107:
          return I(e, ":", ":" + T) + e;

        case 101:
          return I(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + T + (45 === R(e, 14) ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + _ + "$2box$3") + e;
      }

      break;

    case 5936:
      switch (R(e, t + 11)) {
        case 114:
          return T + e + _ + I(e, /[svh]\w+-[tblr]{2}/, "tb") + e;

        case 108:
          return T + e + _ + I(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;

        case 45:
          return T + e + _ + I(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }

      return T + e + _ + e + e;
  }

  return e;
}

function he(e, t) {
  for (var n = "", r = P(e), i = 0; i < r; i++) {
    n += t(e[i], i, e, t) || "";
  }

  return n;
}

function ge(e, t, n, r) {
  switch (e.type) {
    case "@import":
    case "decl":
      return e.return = e.return || e.value;

    case "comm":
      return "";

    case "@keyframes":
      return e.return = e.value + "{" + he(e.children, r) + "}";

    case "rule":
      e.value = e.props.join(",");
  }

  return M(n = he(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}

function ve(e) {
  var t = P(e);
  return function (n, r, i, o) {
    for (var a = "", s = 0; s < t; s++) {
      a += e[s](n, r, i, o) || "";
    }

    return a;
  };
}

var ye,
    be,
    Ee = function Ee(e, t, n) {
  for (var r = 0, i = 0; r = i, i = K(), 38 === r && 12 === i && (t[n] = 1), !ee(i);) {
    X();
  }

  return Q(e, q);
},
    we = function we(e, t) {
  return ne(function (e, t) {
    var n = -1,
        r = 44;

    do {
      switch (ee(r)) {
        case 0:
          38 === r && 12 === K() && (t[n] = 1), e[n] += Ee(q - 1, t, n);
          break;

        case 2:
          e[n] += re(r);
          break;

        case 4:
          if (44 === r) {
            e[++n] = 58 === K() ? "&\f" : "", t[n] = e[n].length;
            break;
          }

        default:
          e[n] += L(r);
      }
    } while (r = X());

    return e;
  }(te(e), t));
},
    Ne = new WeakMap(),
    xe = function xe(e) {
  if ("rule" === e.type && e.parent && !(e.length < 1)) {
    for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; "rule" !== n.type;) {
      if (!(n = n.parent)) return;
    }

    if ((1 !== e.props.length || 58 === t.charCodeAt(0) || Ne.get(n)) && !r) {
      Ne.set(e, !0);

      for (var i = [], o = we(t, i), a = n.props, s = 0, l = 0; s < o.length; s++) {
        for (var c = 0; c < a.length; c++, l++) {
          e.props[l] = i[s] ? o[s].replace(/&\f/g, a[c]) : a[c] + " " + o[s];
        }
      }
    }
  }
},
    ke = function ke(e) {
  if ("decl" === e.type) {
    var t = e.value;
    108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
  }
},
    Oe = function Oe(e) {
  return 105 === e.type.charCodeAt(1) && 64 === e.type.charCodeAt(0);
},
    Ce = function Ce(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
},
    _e = function _e(e, t, n) {
  Oe(e) && (e.parent || function (e, t) {
    for (var n = e - 1; n >= 0; n--) {
      if (!Oe(t[n])) return !0;
    }

    return !1;
  }(t, n)) && Ce(e);
},
    Se = "undefined" != typeof document,
    Te = Se ? void 0 : (ye = function ye() {
  return x(function () {
    var e = {};
    return function (t) {
      return e[t];
    };
  });
}, be = new WeakMap(), function (e) {
  if (be.has(e)) return be.get(e);
  var t = ye(e);
  return be.set(e, t), t;
}),
    Ae = [function (e, t, n, r) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case "decl":
      e.return = pe(e.value, e.length);
      break;

    case "@keyframes":
      return he([G(e, {
        value: I(e.value, "@", "@" + T)
      })], r);

    case "rule":
      if (e.length) return function (e, t) {
        return e.map(t).join("");
      }(e.props, function (t) {
        switch (function (e, t) {
          return (e = t.exec(e)) ? e[0] : e;
        }(t, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return he([G(e, {
              props: [I(t, /:(read-\w+)/, ":-moz-$1")]
            })], r);

          case "::placeholder":
            return he([G(e, {
              props: [I(t, /:(plac\w+)/, ":-webkit-input-$1")]
            }), G(e, {
              props: [I(t, /:(plac\w+)/, ":-moz-$1")]
            }), G(e, {
              props: [I(t, /:(plac\w+)/, _ + "input-$1")]
            })], r);
        }

        return "";
      });
  }
}],
    Le = function Le(e) {
  var t = e.key;
  if ("production" !== process.env.NODE_ENV && !t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");

  if (Se && "css" === t) {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function (e) {
      -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", ""));
    });
  }

  var r = e.stylisPlugins || Ae;
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i,
      o,
      a = {},
      s = [];
  Se && (i = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (e) {
    for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) {
      a[t[n]] = !0;
    }

    s.push(e);
  }));
  var l,
      c = [xe, ke];

  if ("production" !== process.env.NODE_ENV && c.push(function (e) {
    return function (t, n, r) {
      if ("rule" === t.type) {
        var i,
            o = t.value.match(/(:first|:nth|:nth-last)-child/g);

        if (o && !0 !== e.compat) {
          var a = n > 0 ? r[n - 1] : null;
          if (a && function (e) {
            return !!e && "comm" === e.type && e.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
          }((i = a.children).length ? i[i.length - 1] : null)) return;
          o.forEach(function (e) {});
        }
      }
    };
  }({
    get compat() {
      return v.compat;
    }

  }), _e), Se) {
    var u,
        d = [ge, "production" !== process.env.NODE_ENV ? function (e) {
      e.root || (e.return ? u.insert(e.return) : e.value && "comm" !== e.type && u.insert(e.value + "{}"));
    } : (l = function l(e) {
      u.insert(e);
    }, function (e) {
      e.root || (e = e.return) && l(e);
    })],
        f = ve(c.concat(r, d));

    o = function o(e, t, n, r) {
      u = n, "production" !== process.env.NODE_ENV && void 0 !== t.map && (u = {
        insert: function insert(e) {
          n.insert(e + t.map);
        }
      }), he(ce(e ? e + "{" + t.styles + "}" : t.styles), f), r && (v.inserted[t.name] = !0);
    };
  } else {
    var m = [ge],
        p = ve(c.concat(r, m)),
        h = Te(r)(t),
        g = function g(e, t) {
      var n = t.name;
      return void 0 === h[n] && (h[n] = he(ce(e ? e + "{" + t.styles + "}" : t.styles), p)), h[n];
    };

    o = function o(e, t, n, r) {
      var i = t.name,
          o = g(e, t);
      return void 0 === v.compat ? (r && (v.inserted[i] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? o + t.map : o) : r ? void (v.inserted[i] = o) : o;
    };
  }

  var v = {
    key: t,
    sheet: new C({
      key: t,
      container: i,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: o
  };
  return v.sheet.hydrate(s), v;
},
    De = {
  exports: {}
},
    Ve = {},
    Ie = "function" == typeof Symbol && Symbol.for,
    je = Ie ? Symbol.for("react.element") : 60103,
    Re = Ie ? Symbol.for("react.portal") : 60106,
    $e = Ie ? Symbol.for("react.fragment") : 60107,
    Me = Ie ? Symbol.for("react.strict_mode") : 60108,
    Pe = Ie ? Symbol.for("react.profiler") : 60114,
    ze = Ie ? Symbol.for("react.provider") : 60109,
    We = Ie ? Symbol.for("react.context") : 60110,
    He = Ie ? Symbol.for("react.async_mode") : 60111,
    Fe = Ie ? Symbol.for("react.concurrent_mode") : 60111,
    qe = Ie ? Symbol.for("react.forward_ref") : 60112,
    Be = Ie ? Symbol.for("react.suspense") : 60113,
    Ue = Ie ? Symbol.for("react.suspense_list") : 60120,
    Ye = Ie ? Symbol.for("react.memo") : 60115,
    Ge = Ie ? Symbol.for("react.lazy") : 60116,
    Ze = Ie ? Symbol.for("react.block") : 60121,
    Xe = Ie ? Symbol.for("react.fundamental") : 60117,
    Ke = Ie ? Symbol.for("react.responder") : 60118,
    Je = Ie ? Symbol.for("react.scope") : 60119;

function Qe(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case je:
        switch (e = e.type) {
          case He:
          case Fe:
          case $e:
          case Pe:
          case Me:
          case Be:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case We:
              case qe:
              case Ge:
              case Ye:
              case ze:
                return e;

              default:
                return t;
            }

        }

      case Re:
        return t;
    }
  }
}

function et(e) {
  return Qe(e) === Fe;
}

Ve.AsyncMode = He, Ve.ConcurrentMode = Fe, Ve.ContextConsumer = We, Ve.ContextProvider = ze, Ve.Element = je, Ve.ForwardRef = qe, Ve.Fragment = $e, Ve.Lazy = Ge, Ve.Memo = Ye, Ve.Portal = Re, Ve.Profiler = Pe, Ve.StrictMode = Me, Ve.Suspense = Be, Ve.isAsyncMode = function (e) {
  return et(e) || Qe(e) === He;
}, Ve.isConcurrentMode = et, Ve.isContextConsumer = function (e) {
  return Qe(e) === We;
}, Ve.isContextProvider = function (e) {
  return Qe(e) === ze;
}, Ve.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === je;
}, Ve.isForwardRef = function (e) {
  return Qe(e) === qe;
}, Ve.isFragment = function (e) {
  return Qe(e) === $e;
}, Ve.isLazy = function (e) {
  return Qe(e) === Ge;
}, Ve.isMemo = function (e) {
  return Qe(e) === Ye;
}, Ve.isPortal = function (e) {
  return Qe(e) === Re;
}, Ve.isProfiler = function (e) {
  return Qe(e) === Pe;
}, Ve.isStrictMode = function (e) {
  return Qe(e) === Me;
}, Ve.isSuspense = function (e) {
  return Qe(e) === Be;
}, Ve.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === $e || e === Fe || e === Pe || e === Me || e === Be || e === Ue || "object" == typeof e && null !== e && (e.$$typeof === Ge || e.$$typeof === Ye || e.$$typeof === ze || e.$$typeof === We || e.$$typeof === qe || e.$$typeof === Xe || e.$$typeof === Ke || e.$$typeof === Je || e.$$typeof === Ze);
}, Ve.typeOf = Qe;
var tt = {};
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      i = e ? Symbol.for("react.strict_mode") : 60108,
      o = e ? Symbol.for("react.profiler") : 60114,
      a = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      f = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      p = e ? Symbol.for("react.lazy") : 60116,
      h = e ? Symbol.for("react.block") : 60121,
      g = e ? Symbol.for("react.fundamental") : 60117,
      v = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;

  function b(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;

      switch (f) {
        case t:
          var h = e.type;

          switch (h) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case d:
              return h;

            default:
              var g = h && h.$$typeof;

              switch (g) {
                case s:
                case u:
                case p:
                case m:
                case a:
                  return g;

                default:
                  return f;
              }

          }

        case n:
          return f;
      }
    }
  }

  var E = l,
      w = c,
      N = s,
      x = a,
      k = t,
      O = u,
      C = r,
      _ = p,
      S = m,
      T = n,
      A = o,
      L = i,
      D = d,
      V = !1;

  function I(e) {
    return b(e) === c;
  }

  tt.AsyncMode = E, tt.ConcurrentMode = w, tt.ContextConsumer = N, tt.ContextProvider = x, tt.Element = k, tt.ForwardRef = O, tt.Fragment = C, tt.Lazy = _, tt.Memo = S, tt.Portal = T, tt.Profiler = A, tt.StrictMode = L, tt.Suspense = D, tt.isAsyncMode = function (e) {
    return V || (V = !0), I(e) || b(e) === l;
  }, tt.isConcurrentMode = I, tt.isContextConsumer = function (e) {
    return b(e) === s;
  }, tt.isContextProvider = function (e) {
    return b(e) === a;
  }, tt.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, tt.isForwardRef = function (e) {
    return b(e) === u;
  }, tt.isFragment = function (e) {
    return b(e) === r;
  }, tt.isLazy = function (e) {
    return b(e) === p;
  }, tt.isMemo = function (e) {
    return b(e) === m;
  }, tt.isPortal = function (e) {
    return b(e) === n;
  }, tt.isProfiler = function (e) {
    return b(e) === o;
  }, tt.isStrictMode = function (e) {
    return b(e) === i;
  }, tt.isSuspense = function (e) {
    return b(e) === d;
  }, tt.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === c || e === o || e === i || e === d || e === f || "object" == typeof e && null !== e && (e.$$typeof === p || e.$$typeof === m || e.$$typeof === a || e.$$typeof === s || e.$$typeof === u || e.$$typeof === g || e.$$typeof === v || e.$$typeof === y || e.$$typeof === h);
  }, tt.typeOf = b;
}(), "production" === process.env.NODE_ENV ? De.exports = Ve : De.exports = tt;
var nt = De.exports,
    rt = {};
rt[nt.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, rt[nt.Memo] = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
};
var it = "undefined" != typeof document;

function ot(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n] + ";") : r += n + " ";
  }), r;
}

var at = function at(e, t, n) {
  var r = e.key + "-" + t.name;

  if ((!1 === n || !1 === it && void 0 !== e.compat) && void 0 === e.registered[r] && (e.registered[r] = t.styles), void 0 === e.inserted[t.name]) {
    var i = "",
        o = t;

    do {
      var a = e.insert(t === o ? "." + r : "", o, e.sheet, !0);
      it || void 0 === a || (i += a), o = o.next;
    } while (void 0 !== o);

    if (!it && 0 !== i.length) return i;
  }
};

var st = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    lt = /[A-Z]|^ms/g,
    ct = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    ut = function ut(e) {
  return 45 === e.charCodeAt(1);
},
    dt = function dt(e) {
  return null != e && "boolean" != typeof e;
},
    ft = x(function (e) {
  return ut(e) ? e : e.replace(lt, "-$&").toLowerCase();
}),
    mt = function mt(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if ("string" == typeof t) return t.replace(ct, function (e, t, n) {
        return Et = {
          name: t,
          styles: n,
          next: Et
        }, t;
      });
  }

  return 1 === st[e] || ut(e) || "number" != typeof t || 0 === t ? t : t + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var pt = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/,
      ht = ["normal", "none", "initial", "inherit", "unset"],
      gt = mt,
      vt = {};

  mt = function mt(e, t) {
    if ("content" === e && ("string" != typeof t || -1 === ht.indexOf(t) && !pt.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = gt(e, t);
    return "" === n || ut(e) || -1 === e.indexOf("-") || void 0 !== vt[e] || (vt[e] = !0), n;
  };
}

function yt(e, t, n) {
  if (null == n) return "";

  if (void 0 !== n.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return n;
  }

  switch (typeof n) {
    case "boolean":
      return "";

    case "object":
      if (1 === n.anim) return Et = {
        name: n.name,
        styles: n.styles,
        next: Et
      }, n.name;

      if (void 0 !== n.styles) {
        var r = n.next;
        if (void 0 !== r) for (; void 0 !== r;) {
          Et = {
            name: r.name,
            styles: r.styles,
            next: Et
          }, r = r.next;
        }
        var i = n.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== n.map && (i += n.map), i;
      }

      return function (e, t, n) {
        var r = "";
        if (Array.isArray(n)) for (var i = 0; i < n.length; i++) {
          r += yt(e, t, n[i]) + ";";
        } else for (var o in n) {
          var a = n[o];
          if ("object" != typeof a) null != t && void 0 !== t[a] ? r += o + "{" + t[a] + "}" : dt(a) && (r += ft(o) + ":" + mt(o, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === o && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");

            if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
              var s = yt(e, t, a);

              switch (o) {
                case "animation":
                case "animationName":
                  r += ft(o) + ":" + s + ";";
                  break;

                default:
                  process.env.NODE_ENV, r += o + "{" + s + "}";
              }
            } else for (var l = 0; l < a.length; l++) {
              dt(a[l]) && (r += ft(o) + ":" + mt(o, a[l]) + ";");
            }
          }
        }
        return r;
      }(e, t, n);

    case "function":
      if (void 0 !== e) {
        var o = Et,
            a = n(e);
        return Et = o, yt(e, t, a);
      }

      process.env.NODE_ENV;
      break;

    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var s = [];
        n.replace(ct, function (e, t, n) {
          var r = "animation" + s.length;
          return s.push("const " + r + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
        });
        s.length;
      }

  }

  if (null == t) return n;
  var l = t[n];
  return void 0 !== l ? l : n;
}

var bt,
    Et,
    wt = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
"production" !== process.env.NODE_ENV && (bt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);

var Nt = function Nt(e, t, n) {
  if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
  var r = !0,
      i = "";
  Et = void 0;
  var o,
      a = e[0];
  null == a || void 0 === a.raw ? (r = !1, i += yt(n, t, a)) : ("production" !== process.env.NODE_ENV && a[0], i += a[0]);

  for (var s = 1; s < e.length; s++) {
    i += yt(n, t, e[s]), r && ("production" !== process.env.NODE_ENV && a[s], i += a[s]);
  }

  "production" !== process.env.NODE_ENV && (i = i.replace(bt, function (e) {
    return o = e, "";
  })), wt.lastIndex = 0;

  for (var l, c = ""; null !== (l = wt.exec(i));) {
    c += "-" + l[1];
  }

  var u = function (e) {
    for (var t, n = 0, r = 0, i = e.length; i >= 4; ++r, i -= 4) {
      t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
    }

    switch (i) {
      case 3:
        n ^= (255 & e.charCodeAt(r + 2)) << 16;

      case 2:
        n ^= (255 & e.charCodeAt(r + 1)) << 8;

      case 1:
        n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + (59797 * (n >>> 16) << 16);
    }

    return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
  }(i) + c;

  return "production" !== process.env.NODE_ENV ? {
    name: u,
    styles: i,
    map: o,
    next: Et,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: i,
    next: Et
  };
},
    xt = "undefined" != typeof document,
    kt = {}.hasOwnProperty,
    Ot = s("undefined" != typeof HTMLElement ? Le({
  key: "css"
}) : null);

"production" !== process.env.NODE_ENV && (Ot.displayName = "EmotionCacheContext"), Ot.Provider;

var Ct = function Ct(e) {
  return i(function (t, n) {
    var r = o(Ot);
    return e(t, r, n);
  });
};

xt || (Ct = function Ct(e) {
  return function (t) {
    var n = o(Ot);
    return null === n ? (n = Le({
      key: "css"
    }), a(Ot.Provider, {
      value: n
    }, e(t, n))) : e(t, n);
  };
});

var _t = s({});

"production" !== process.env.NODE_ENV && (_t.displayName = "EmotionThemeContext");

var St = function St() {
  return null;
},
    Tt = Ct(function (e, t, n) {
  var r = e.css;
  "string" == typeof r && void 0 !== t.registered[r] && (r = t.registered[r]);
  var i = e.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      s = [r],
      c = "";
  "string" == typeof e.className ? c = ot(t.registered, s, e.className) : null != e.className && (c = e.className + " ");
  var u = Nt(s, void 0, o(_t));

  if ("production" !== process.env.NODE_ENV && -1 === u.name.indexOf("-")) {
    var d = e.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    d && (u = Nt([u, "label:" + d + ";"]));
  }

  var f = at(t, u, "string" == typeof i);
  c += t.key + "-" + u.name;
  var m = {};

  for (var p in e) {
    !kt.call(e, p) || "css" === p || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === p || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === p || (m[p] = e[p]);
  }

  m.ref = n, m.className = c;
  var h = a(i, m),
      g = a(St, null);

  if (!xt && void 0 !== f) {
    for (var v, y = u.name, b = u.next; void 0 !== b;) {
      y += " " + b.name, b = b.next;
    }

    g = a("style", ((v = {})["data-emotion"] = t.key + " " + y, v.dangerouslySetInnerHTML = {
      __html: f
    }, v.nonce = t.sheet.nonce, v));
  }

  return a(l, null, g, h);
});

"production" !== process.env.NODE_ENV && (Tt.displayName = "EmotionCssPropInternal");
var At = !1,
    Lt = Ct(function (e, t) {
  "production" === process.env.NODE_ENV || At || !e.className && !e.css || (At = !0);
  var n = e.styles,
      r = Nt([n], void 0, o(_t));

  if (!xt) {
    for (var i, s = r.name, l = r.styles, d = r.next; void 0 !== d;) {
      s += " " + d.name, l += d.styles, d = d.next;
    }

    var f = !0 === t.compat,
        m = t.insert("", {
      name: s,
      styles: l
    }, t.sheet, f);
    return f ? null : a("style", ((i = {})["data-emotion"] = t.key + "-global " + s, i.dangerouslySetInnerHTML = {
      __html: m
    }, i.nonce = t.sheet.nonce, i));
  }

  var p = c();
  return u(function () {
    var e = t.key + "-global",
        n = new C({
      key: e,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }),
        i = !1,
        o = document.querySelector('style[data-emotion="' + e + " " + r.name + '"]');
    return t.sheet.tags.length && (n.before = t.sheet.tags[0]), null !== o && (i = !0, o.setAttribute("data-emotion", e), n.hydrate([o])), p.current = [n, i], function () {
      n.flush();
    };
  }, [t]), u(function () {
    var e = p.current,
        n = e[0];
    if (e[1]) e[1] = !1;else {
      if (void 0 !== r.next && at(t, r.next, !0), n.tags.length) {
        var i = n.tags[n.tags.length - 1].nextElementSibling;
        n.before = i, n.flush();
      }

      t.insert("", r, n, !1);
    }
  }, [t, r.name]), null;
});

function Dt() {
  for (var e = arguments, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
    n[r] = e[r];
  }

  return Nt(n);
}

"production" !== process.env.NODE_ENV && (Lt.displayName = "EmotionGlobal");

var Vt = function Vt() {
  var e = Dt.apply(void 0, arguments),
      t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
},
    It = function e(t) {
  for (var n = t.length, r = 0, i = ""; r < n; r++) {
    var o = t[r];

    if (null != o) {
      var a = void 0;

      switch (typeof o) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(o)) a = e(o);else for (var s in "production" !== process.env.NODE_ENV && void 0 !== o.styles && o.name, a = "", o) {
            o[s] && s && (a && (a += " "), a += s);
          }
          break;

        default:
          a = o;
      }

      a && (i && (i += " "), i += a);
    }
  }

  return i;
};

function jt(e, t, n) {
  var r = [],
      i = ot(e, r, n);
  return r.length < 2 ? n : i + t(r);
}

var Rt = function Rt() {
  return null;
},
    $t = Ct(function (e, t) {
  var n = "",
      r = "",
      i = !1,
      s = function s() {
    var e = arguments;
    if (i && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");

    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) {
      a[s] = e[s];
    }

    var l = Nt(a, t.registered);
    if (xt) at(t, l, !1);else {
      var c = at(t, l, !1);
      void 0 !== c && (n += c);
    }
    return xt || (r += " " + l.name), t.key + "-" + l.name;
  },
      c = {
    css: s,
    cx: function cx() {
      var e = arguments;
      if (i && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");

      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
        r[o] = e[o];
      }

      return jt(t.registered, s, It(r));
    },
    theme: o(_t)
  },
      u = e.children(c);

  i = !0;
  var d,
      f = a(Rt, null);
  xt || 0 === n.length || (f = a("style", ((d = {})["data-emotion"] = t.key + " " + r.substring(1), d.dangerouslySetInnerHTML = {
    __html: n
  }, d.nonce = t.sheet.nonce, d)));
  return a(l, null, f, u);
});

if ("production" !== process.env.NODE_ENV && ($t.displayName = "EmotionClassNames"), "production" !== process.env.NODE_ENV) {
  var Mt = "undefined" != typeof document,
      Pt = "undefined" != typeof jest;

  if (Mt && !Pt) {
    var zt = "undefined" != typeof globalThis ? globalThis : Mt ? window : global,
        Wt = "__EMOTION_REACT_" + "11.7.1".split(".")[0] + "__";
    zt[Wt], zt[Wt] = !0;
  }
}

var Ht = O,
    Ft = function Ft(e) {
  return "theme" !== e;
},
    qt = function qt(e) {
  return "string" == typeof e && e.charCodeAt(0) > 96 ? Ht : Ft;
},
    Bt = function Bt(e, t, n) {
  var r;

  if (t) {
    var i = t.shouldForwardProp;
    r = e.__emotion_forwardProp && i ? function (t) {
      return e.__emotion_forwardProp(t) && i(t);
    } : i;
  }

  return "function" != typeof r && n && (r = e.__emotion_forwardProp), r;
},
    Ut = "undefined" != typeof document,
    Yt = function Yt() {
  return null;
},
    Gt = function e(t, n) {
  if ("production" !== process.env.NODE_ENV && void 0 === t) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var r,
      i,
      s = t.__emotion_real === t,
      c = s && t.__emotion_base || t;
  void 0 !== n && (r = n.label, i = n.target);
  var u = Bt(t, n, s),
      d = u || qt(c),
      f = !d("as");
  return function () {
    var m = arguments,
        p = s && void 0 !== t.__emotion_styles ? t.__emotion_styles.slice(0) : [];
    if (void 0 !== r && p.push("label:" + r + ";"), null == m[0] || void 0 === m[0].raw) p.push.apply(p, m);else {
      "production" !== process.env.NODE_ENV && m[0][0], p.push(m[0][0]);

      for (var h = m.length, g = 1; g < h; g++) {
        "production" !== process.env.NODE_ENV && m[0][g], p.push(m[g], m[0][g]);
      }
    }
    var v = Ct(function (e, t, n) {
      var r = f && e.as || c,
          s = "",
          m = [],
          h = e;

      if (null == e.theme) {
        for (var g in h = {}, e) {
          h[g] = e[g];
        }

        h.theme = o(_t);
      }

      "string" == typeof e.className ? s = ot(t.registered, m, e.className) : null != e.className && (s = e.className + " ");
      var v = Nt(p.concat(m), t.registered, h),
          y = at(t, v, "string" == typeof r);
      s += t.key + "-" + v.name, void 0 !== i && (s += " " + i);
      var b = f && void 0 === u ? qt(r) : d,
          E = {};

      for (var w in e) {
        f && "as" === w || b(w) && (E[w] = e[w]);
      }

      E.className = s, E.ref = n;
      var N = a(r, E),
          x = a(Yt, null);

      if (!Ut && void 0 !== y) {
        for (var k, O = v.name, C = v.next; void 0 !== C;) {
          O += " " + C.name, C = C.next;
        }

        x = a("style", ((k = {})["data-emotion"] = t.key + " " + O, k.dangerouslySetInnerHTML = {
          __html: y
        }, k.nonce = t.sheet.nonce, k));
      }

      return a(l, null, x, N);
    });
    return v.displayName = void 0 !== r ? r : "Styled(" + ("string" == typeof c ? c : c.displayName || c.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = c, v.__emotion_styles = p, v.__emotion_forwardProp = u, Object.defineProperty(v, "toString", {
      value: function value() {
        return void 0 === i && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + i;
      }
    }), v.withComponent = function (t, r) {
      return e(t, N({}, n, r, {
        shouldForwardProp: Bt(v, r, !0)
      })).apply(void 0, p);
    }, v;
  };
};

var Zt = Gt("ul", "production" === process.env.NODE_ENV ? {
  target: "e1fht2ox6"
} : {
  target: "e1fht2ox6",
  label: "TimelineNavWrapper"
})("production" === process.env.NODE_ENV ? {
  name: "ql8rfu",
  styles: "background:rgba(229, 229, 229, 0.85);border-radius:25px;display:flex;list-style:none;padding:0.25em 0.25em"
} : {
  name: "ql8rfu",
  styles: "background:rgba(229, 229, 229, 0.85);border-radius:25px;display:flex;list-style:none;padding:0.25em 0.25em",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
}),
    Xt = Gt("li", "production" === process.env.NODE_ENV ? {
  target: "e1fht2ox5"
} : {
  target: "e1fht2ox5",
  label: "TimelineNavItem"
})("padding:0.1em;display:flex;align-items:center;justify-content:center;", function (e) {
  return e.disable ? "pointer-events: none; filter: opacity(0.7)" : "";
}, ";"),
    Kt = Gt("button", "production" === process.env.NODE_ENV ? {
  target: "e1fht2ox4"
} : {
  target: "e1fht2ox4",
  label: "TimelineNavButton"
})("align-items:center;background:", function (e) {
  return e.theme.primary;
}, ";border-radius:50%;border:0;color:#fff;cursor:pointer;display:flex;filter:drop-shadow(0 0 5px rgba(0, 0, 0, 0.25));height:20px;justify-content:center;margin:0 0.2em;padding:0;transition:all 0.1s ease-in;width:20px;transform:", function (e) {
  if ("TRUE" === e.rotate) return "rotate(90deg)";
}, ";&:active{filter:drop-shadow(0 0 2px rgba(0, 0, 0, 0.25));transform:", function (e) {
  return "TRUE" === e.rotate ? "rotate(90deg)" : "";
}, " scale(0.9);}svg{width:80%;height:80%;}"),
    Jt = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1fht2ox3"
} : {
  target: "e1fht2ox3",
  label: "TimelineControlContainer"
})("align-items:center;display:flex;justify-content:center;visibility:", function (e) {
  return e.slideShowActive ? "hidden" : "visible";
}, ";");
Gt("button", "production" === process.env.NODE_ENV ? {
  target: "e1fht2ox2"
} : {
  target: "e1fht2ox2",
  label: "ControlButton"
})("align-items:center;background:", function (e) {
  return e.theme.primary;
}, ";border-radius:50%;cursor:pointer;display:flex;height:2em;justify-content:center;margin-left:0.5em;width:2em;outline:0;color:#fff;svg{width:80%;height:80%;}");
var Qt = t.memo(function (e) {
  var n = e.onNext,
      i = e.onPrevious,
      a = e.onFirst,
      s = e.onLast,
      l = e.disableLeft,
      c = e.disableRight,
      u = e.theme,
      d = e.slideShowRunning,
      f = e.onReplay,
      m = e.slideShowEnabled,
      h = o(p).mode,
      g = r(function () {
    return "HORIZONTAL" !== h;
  }, [h]);
  return t.createElement(Jt, {
    slideShowActive: d
  }, t.createElement(Zt, {
    className: "timeline-controls"
  }, t.createElement(Xt, {
    disable: l
  }, t.createElement(Kt, {
    mode: h,
    theme: u,
    onClick: a,
    title: "Go to First",
    "aria-label": "first",
    "aria-disabled": l,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: l ? -1 : 0,
    rotate: g ? "TRUE" : "FALSE"
  }, t.createElement(b, null))), t.createElement(Xt, {
    disable: l
  }, t.createElement(Kt, {
    mode: h,
    theme: u,
    onClick: i,
    title: "Previous",
    "aria-label": "previous",
    "aria-disabled": l,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: l ? -1 : 0,
    rotate: g ? "TRUE" : "FALSE"
  }, t.createElement(v, null))), t.createElement(Xt, {
    disable: c
  }, t.createElement(Kt, {
    mode: h,
    theme: u,
    onClick: n,
    title: "Next",
    "aria-label": "next",
    "aria-disabled": c,
    "aria-controls": "timeline-main-wrapper",
    rotate: g ? "TRUE" : "FALSE",
    tabIndex: c ? -1 : 0
  }, t.createElement(y, null))), t.createElement(Xt, {
    disable: c
  }, t.createElement(Kt, {
    mode: h,
    theme: u,
    onClick: s,
    title: "Go to Last",
    "aria-label": "last",
    "aria-disabled": c,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: c ? -1 : 0,
    rotate: g ? "TRUE" : "FALSE"
  }, t.createElement(E, null))), t.createElement(Xt, null, m && t.createElement(Kt, {
    theme: u,
    onClick: f,
    title: "Play Slideshow",
    tabIndex: 0,
    "aria-controls": "timeline-main-wrapper",
    "aria-label": "Play Slideshow"
  }, t.createElement(w, null)))));
});
Qt.displayName = "Timeline Control";
var en,
    tn = {
  exports: {}
};
en = tn, function () {
  var e = {}.hasOwnProperty;

  function t() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i];

      if (o) {
        var a = typeof o;
        if ("string" === a || "number" === a) r.push(o);else if (Array.isArray(o)) {
          if (o.length) {
            var s = t.apply(null, o);
            s && r.push(s);
          }
        } else if ("object" === a) if (o.toString === Object.prototype.toString) for (var l in o) {
          e.call(o, l) && o[l] && r.push(l);
        } else r.push(o.toString());
      }
    }

    return r.join(" ");
  }

  en.exports ? (t.default = t, en.exports = t) : window.classNames = t;
}();
var nn = tn.exports;

function rn() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var on = Gt("section", "production" === process.env.NODE_ENV ? {
  target: "emk90bu10"
} : {
  target: "emk90bu10",
  label: "TimelineItemContentWrapper"
})("align-items:flex-start;background:", function (e) {
  return e.theme.cardBgColor;
}, ";border-radius:4px;display:flex;", function (e) {
  return e.borderLess ? "none" : "filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2))";
}, ";flex-direction:column;justify-content:flex-start;line-height:1.5em;margin:", function (e) {
  return "HORIZONTAL" === e.mode ? "0 auto" : "VERTICAL_ALTERNATING" !== e.mode ? "1em 0" : "";
}, ";max-width:", function (e) {
  return e.maxWidth;
}, "px;min-height:", function (e) {
  return e.minHeight;
}, "px;position:relative;text-align:left;width:98%;z-index:0;&:focus{outline:1px solid ", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, ";}"),
    an = Gt("header", "production" === process.env.NODE_ENV ? {
  target: "emk90bu9"
} : {
  target: "emk90bu9",
  label: "TimelineCardHeader"
})("production" === process.env.NODE_ENV ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  toString: rn
}),
    sn = Gt("p", "production" === process.env.NODE_ENV ? {
  target: "emk90bu8"
} : {
  target: "emk90bu8",
  label: "TimelineContentSubTitle"
})("color:", function (e) {
  return e.theme.primary;
}, ";font-size:0.85rem;font-weight:600;margin:0;padding-left:0.5rem;text-align:left;width:97%;"),
    ln = Gt("p", "production" === process.env.NODE_ENV ? {
  target: "emk90bu7"
} : {
  target: "emk90bu7",
  label: "TimelineCardTitle"
})("color:", function (e) {
  return e.theme.cardForeColor;
}, ";font-size:1rem;font-weight:600;margin-top:0.5em;margin:0;padding-left:0.5em;padding-top:0.25em;&.active{color:", function (e) {
  return e.theme.primary;
}, ";}text-align:left;width:95%;"),
    cn = Gt("p", "production" === process.env.NODE_ENV ? {
  target: "emk90bu6"
} : {
  target: "emk90bu6",
  label: "TimelineContentDetails"
})("color:", function (e) {
  return e.theme.cardForeColor;
}, ";font-size:0.85rem;font-weight:400;margin:0;touch-action:none;width:100%;"),
    un = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "emk90bu5"
} : {
  target: "emk90bu5",
  label: "TimelineSubContent"
})("production" === process.env.NODE_ENV ? {
  name: "1v43pgp",
  styles: "margin-bottom:0.5rem;display:block"
} : {
  name: "1v43pgp",
  styles: "margin-bottom:0.5rem;display:block",
  toString: rn
}),
    dn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "emk90bu4"
} : {
  target: "emk90bu4",
  label: "TimelineContentDetailsWrapper"
})("align-items:center;display:flex;flex-direction:column;font-size:0.8rem;margin:0 auto;margin-top:0.5em;margin-bottom:0.5em;", function (e) {
  return e.useReadMore && !e.customContent ? "max-height: 150px;" : "";
}, " overflow-x:hidden;overflow-y:auto;scrollbar-color:", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, " default;scrollbar-width:thin;transition:max-height 100ms linear;width:", function (e) {
  return e.borderLess ? "100%" : "95%";
}, ";padding:0.25em 0.5em;&::-webkit-scrollbar{width:0.3em;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0, 0, 0, 0.2);}&::-webkit-scrollbar-thumb{background-color:", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, ";outline:1px solid ", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, ";}&.show-less{max-height:50px;scrollbar-width:none;overflow:hidden;&::-webkit-scrollbar{width:0;}}"),
    fn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "emk90bu3"
} : {
  target: "emk90bu3",
  label: "ShowMore"
})("align-items:center;align-self:flex-end;border-radius:4px;cursor:pointer;display:", function (e) {
  return e.show ? "flex" : "none";
}, ";font-size:0.75rem;justify-self:flex-end;margin-bottom:0.5em;margin-left:0.5em;margin-right:0.5em;margin-top:auto;padding:0.25em;&:hover{color:", function (e) {
  return e.theme.primary;
}, ";}"),
    mn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "emk90bu2"
} : {
  target: "emk90bu2",
  label: "SlideShowProgressBar"
})("background:", function (e) {
  return e.color;
}, ";bottom:-0.75em;display:block;height:3px;left:0;position:absolute;", function (e) {
  return !e.paused && e.startWidth && e.startWidth > 0 ? Dt("animation:", (t = e.startWidth, Vt(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    width: ", "px;\n  }\n  100% {\n    width: ", "px;\n  }  \n"])), t, 0)), " ", e.duration, "ms ease-in;animation-play-state:running;" + ("production" === process.env.NODE_ENV ? "" : ";label:SlideShowProgressBar;")) : Dt("animation-play-state:paused;width:", e.startWidth, "px;" + ("production" === process.env.NODE_ENV ? "" : ";label:SlideShowProgressBar;"));
  var t;
}, " svg{position:absolute;left:0;top:0;width:100%;}"),
    pn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "emk90bu1"
} : {
  target: "emk90bu1",
  label: "ChevronIconWrapper"
})("align-items:center;display:flex;height:1.25em;justify-content:center;margin-left:0.2em;margin-top:0.2em;width:1.25em;", function (e) {
  return e.collapsed ? "\n      transform: rotate(90deg);\n  " : "transform: rotate(-90deg)";
}, ";svg{height:100%;width:100%;}"),
    hn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "emk90bu0"
} : {
  target: "emk90bu0",
  label: "TriangleIconWrapper"
})("display:flex;align-items:center;justify-content:center;width:1.5rem;height:1.5rem;position:absolute;top:50%;background:", function (e) {
  return e.theme.cardBgColor;
}, ";transform:translateY(-50%) rotate(225deg);z-index:-1;& svg{width:100%;height:100%;fill:#fff;}", function (e) {
  return "left" === e.dir ? "right: -8px;" : "left: -8px;";
}, ";"),
    gn = t.memo(function (e) {
  var n = e.title,
      r = e.url,
      i = e.theme,
      o = e.color,
      a = e.dir,
      s = e.active;
  return n && i ? t.createElement(ln, {
    className: s ? "active card-title" : "card-title",
    theme: i,
    style: {
      color: o
    },
    dir: a
  }, t.createElement("a", {
    href: r,
    target: "_blank",
    rel: "noreferrer"
  }, n)) : null;
}, function () {
  return !0;
});
gn.displayName = "Timeline Title";
var vn = t.memo(function (e) {
  var n = e.content,
      r = e.color,
      i = e.dir,
      o = e.theme;
  return n ? t.createElement(sn, {
    style: {
      color: r
    },
    dir: i,
    theme: o,
    className: "card-sub-title"
  }, n) : null;
}, function () {
  return !0;
});

function yn() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

vn.displayName = "Timeline Content";

var bn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j5"
} : {
  target: "e16bc98j5",
  label: "MediaWrapper"
})(function (e) {
  return e.cardHeight ? "min-height: ".concat(e.cardHeight, "px;") : "";
}, ";align-items:center;align-self:center;background:", function (e) {
  var t;
  return e.active ? "rgba(".concat(null === (t = e.theme) || void 0 === t ? void 0 : t.secondary, ", 0.35)") : "";
}, ";border-radius:4px;flex-direction:row;height:0;padding:0.5em;pointer-events:", function (e) {
  return !e.active && e.slideShowActive ? "none" : "";
}, ";position:relative;text-align:center;width:100%;", function (e) {
  return "HORIZONTAL" === e.mode || "left" === e.dir ? "\n        justify-content: flex-start;\n      " : "\n        justify-content: flex-end;\n      ";
}, ";"),
    En = Gt("img", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j4"
} : {
  target: "e16bc98j4",
  label: "CardImage"
})("flex:4;justify-self:center;margin-left:auto;margin-right:auto;max-height:100%;max-width:100%;object-fit:contain;visibility:", function (e) {
  return e.visible ? "visible" : "hidden";
}, ";"),
    wn = Gt("video", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j3"
} : {
  target: "e16bc98j3",
  label: "CardVideo"
})("production" === process.env.NODE_ENV ? {
  name: "1936w4e",
  styles: "max-width:100%;max-height:100%;margin-left:auto;margin-right:auto"
} : {
  name: "1936w4e",
  styles: "max-width:100%;max-height:100%;margin-left:auto;margin-right:auto",
  toString: yn
}),
    Nn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j2"
} : {
  target: "e16bc98j2",
  label: "MediaDetailsWrapper"
})("bottom:-1em;left:0;right:0;margin-right:auto;width:", function (e) {
  switch (e.mode) {
    case "HORIZONTAL":
    case "VERTICAL":
    case "VERTICAL_ALTERNATING":
      return "100%";
  }
}, ";display:flex;flex-direction:column;flex:1;border-radius:6px;padding-bottom:0.5em;"),
    xn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j1"
} : {
  target: "e16bc98j1",
  label: "ErrorMessage"
})("production" === process.env.NODE_ENV ? {
  name: "sb0sil",
  styles: "color:#a3a3a3;left:50%;position:absolute;text-align:center;top:50%;transform:translateY(-50%) translateX(-50%)"
} : {
  name: "sb0sil",
  styles: "color:#a3a3a3;left:50%;position:absolute;text-align:center;top:50%;transform:translateY(-50%) translateX(-50%)",
  toString: yn
}),
    kn = Gt("iframe", "production" === process.env.NODE_ENV ? {
  target: "e16bc98j0"
} : {
  target: "e16bc98j0",
  label: "IFrameVideo"
})("production" === process.env.NODE_ENV ? {
  name: "1qkt16r",
  styles: "position:relative;height:100%;width:100%"
} : {
  name: "1qkt16r",
  styles: "position:relative;height:100%;width:100%",
  toString: yn
}),
    On = function On(e) {
  var i = e.active,
      a = e.id,
      s = e.onMediaStateChange,
      l = e.theme,
      u = e.title,
      m = e.content,
      h = e.media,
      g = e.slideshowActive;
  e.hideMedia;
  var v = e.cardHeight,
      y = c(null),
      b = n(!1),
      E = b[0],
      w = b[1],
      N = o(p).mode;
  d(function () {
    y && (i ? y.current && y.current.play() : y.current && y.current.pause());
  }, [i]);

  var x = n(!1),
      k = x[0],
      O = x[1],
      C = f(function () {
    O(!0);
  }, []),
      _ = f(function () {
    w(!0), s({
      id: a,
      paused: !1,
      playing: !1
    });
  }, []),
      S = t.memo(function (e) {
    var n = e.message;
    return t.createElement(xn, null, n);
  }),
      T = r(function () {
    return /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/.test(h.source.url);
  }, []),
      A = r(function () {
    return t.createElement(kn, {
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: !0,
      src: "".concat(h.source.url).concat(i ? "?autoplay=1&enablejsapi=1" : "?enablejsapi=1")
    });
  }, [i]),
      L = r(function () {
    return t.createElement(wn, {
      controls: !0,
      autoPlay: i,
      ref: y,
      onLoadedData: C,
      onPlay: function onPlay() {
        return s({
          id: a,
          paused: !1,
          playing: !0
        });
      },
      onPause: function onPause() {
        return s({
          id: a,
          paused: !0,
          playing: !1
        });
      },
      onEnded: function onEnded() {
        return s({
          id: a,
          paused: !1,
          playing: !1
        });
      },
      onError: _
    }, t.createElement("source", {
      src: h.source.url
    }));
  }, [i]),
      D = r(function () {
    return t.createElement(En, {
      src: h.source.url,
      mode: N,
      onLoad: C,
      onError: _,
      visible: k,
      active: i,
      alt: h.name,
      loading: "lazy"
    });
  }, [i, k]);

  return S.displayName = "Error Message", t.createElement(t.Fragment, null, t.createElement(bn, {
    theme: l,
    active: i,
    mode: N,
    slideShowActive: g,
    className: "card-media-wrapper",
    cardHeight: v
  }, "VIDEO" === h.type && !T && (E ? t.createElement(S, {
    message: "Failed to load the video"
  }) : L), "VIDEO" === h.type && T && A, "IMAGE" === h.type && (E ? t.createElement(S, {
    message: "Failed to load the image."
  }) : D)), t.createElement(Nn, {
    mode: N
  }, t.createElement(gn, {
    title: u,
    theme: l,
    active: i
  }), t.createElement(vn, {
    content: m
  })));
},
    Cn = t.memo(function (e) {
  var i = e.active,
      a = e.content,
      s = e.detailedText,
      l = e.id,
      u = e.media,
      m = e.onShowMore,
      h = e.slideShowActive,
      g = e.onElapsed,
      v = e.theme,
      b = e.title,
      E = e.onClick,
      w = e.customContent,
      N = e.hasFocus,
      x = e.flip,
      k = e.branchDir,
      O = e.url,
      C = n(!1),
      _ = C[0],
      S = C[1],
      T = c(null),
      A = c(null),
      L = c(null),
      D = c(0),
      V = c(0),
      I = c(0),
      j = c(),
      R = n(!1),
      $ = R[0],
      M = R[1],
      P = n(0),
      z = P[0],
      W = P[1],
      H = n(0),
      F = H[0],
      q = H[1],
      B = n(!1),
      U = B[0],
      Y = B[1],
      G = o(p),
      Z = G.mode,
      X = G.cardHeight,
      K = G.slideItemDuration;
  void 0 === K && (K = 2e3);
  var J = G.useReadMore,
      Q = G.cardWidth,
      ee = G.borderLessCards,
      te = G.disableAutoScrollOnClick,
      ne = r(function () {
    var e = i && h;
    return u ? e && "VIDEO" !== u.type : e;
  }, [i, h]),
      re = r(function () {
    return !!s;
  }, [s]);
  d(function () {
    var e = T.current;
    e && (e.scrollTop = 0);
  }, [_]);
  var ie = f(function (e) {
    var t = T.current;

    if (e && t) {
      var n = t.scrollHeight,
          r = t.offsetTop;
      D.current = e.clientWidth, q(D.current), Y(n + r > e.clientHeight);
    }
  }, [T.current]),
      oe = f(function (e) {
    K && (W(e), j.current = new Date(), M(!1), I.current = window.setTimeout(function () {
      window.clearTimeout(I.current), M(!0), q(0), W(K), l && g && g(l);
    }, e));
  }, []),
      ae = f(function () {
    if (i && h) {
      if (window.clearTimeout(I.current), M(!0), j.current) {
        var e = +new Date() - +j.current;
        V.current = e;
      }

      L.current && q(L.current.clientWidth);
    }
  }, [i, h]),
      se = f(function () {
    if (i && h) {
      if (!K) return;
      var e = K - V.current;
      M(!1), e > 0 && oe(e);
    }
  }, [i, h, K]);
  d(function () {
    K && (i && h && (q(D.current), oe(K)), i && N && A.current && A.current.focus());
  }, [i, h]), d(function () {
    N && i && A.current && A.current.focus();
  }, [N, i]);
  var le = r(function () {
    return J && s && !w;
  }, []),
      ce = f(function (e) {
    h && (e.playing ? ae() : e.paused && $ && l && g && g(l));
  }, [$, h]),
      ue = r(function () {
    return nn(i ? "timeline-card-content active" : "timeline-card-content ");
  }, [i]),
      de = r(function () {
    return nn(_ || w || !J ? "card-description" : "show-less card-description");
  }, [_, w]),
      fe = f(function () {
    (i && $ || !h) && (S(!_), m());
  }, [i, $, h, _]),
      me = r(function () {
    return x ? "right" === k ? "left" : "right" : k;
  }, [k, x]),
      pe = r(function () {
    return ["VERTICAL", "VERTICAL_ALTERNATING"].some(function (e) {
      return e === Z;
    });
  }, [Z]);
  return t.createElement(on, {
    className: ue,
    minHeight: X,
    maxWidth: Q,
    mode: Z,
    noMedia: !u,
    onClick: function onClick(e) {
      e.stopPropagation(), !h && E && l && !te && E(l);
    },
    onMouseEnter: ae,
    onMouseLeave: se,
    ref: ie,
    tabIndex: 0,
    theme: v,
    borderLess: ee
  }, t.createElement(an, null, !u && t.createElement(gn, {
    title: b,
    theme: v,
    url: O
  }), !u && t.createElement(vn, {
    content: a,
    theme: v
  })), u && t.createElement(On, {
    active: i,
    cardHeight: X,
    content: a,
    hideMedia: _,
    id: l,
    media: u,
    onMediaStateChange: ce,
    slideshowActive: h,
    theme: v,
    title: b
  }), t.createElement(dn, {
    "aria-expanded": _,
    className: de,
    customContent: !!w,
    ref: T,
    theme: v,
    useReadMore: J,
    borderLess: ee
  }, w ? t.createElement(t.Fragment, null, w) : t.createElement(cn, {
    className: _ ? "active" : "",
    ref: T,
    theme: v
  }, Array.isArray(s) ? s.map(function (e, n) {
    return t.createElement(un, {
      key: n
    }, e);
  }) : s)), le && U ? t.createElement(fn, {
    className: "show-more",
    onClick: fe,
    onKeyPress: function onKeyPress(e) {
      "Enter" === e.key && fe();
    },
    role: "button",
    show: re,
    theme: v,
    tabIndex: 0
  }, t.createElement("span", null, _ ? "read less" : "read more"), t.createElement(pn, {
    collapsed: !_
  }, t.createElement(y, null))) : null, ne && t.createElement(mn, {
    color: v && v.primary,
    duration: z,
    paused: $,
    ref: L,
    startWidth: F
  }), pe && t.createElement(hn, {
    dir: me,
    theme: v
  }));
});

Cn.displayName = "TimelineCardContent";

var _n = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "ergoa4r0"
} : {
  target: "ergoa4r0",
  label: "TitleWrapper"
})("border-radius:0.2rem;font-size:0.9rem;font-weight:600;overflow:hidden;padding:0.25rem;visibility:", function (e) {
  return e.hide ? "hidden" : "visible";
}, ";text-align:", function (e) {
  return e.align ? e.align : "";
}, ";&.active{background:", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
}, ";color:", function (e) {
  var t, n, r;
  return (null === (t = e.theme) || void 0 === t ? void 0 : t.titleColor) ? null === (n = e.theme) || void 0 === n ? void 0 : n.titleColor : null === (r = e.theme) || void 0 === r ? void 0 : r.primary;
}, ";}"),
    Sn = function Sn(e) {
  var n = e.title,
      i = e.active,
      o = e.theme,
      a = e.align,
      s = r(function () {
    return nn("timeline-item-title", i ? "active" : "");
  }, [i]);
  return t.createElement(_n, {
    className: s,
    theme: o,
    hide: !n,
    align: a
  }, n);
};

function Tn() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var An = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh875"
} : {
  target: "e5foh875",
  label: "Wrapper"
})("production" === process.env.NODE_ENV ? {
  name: "1gqu14n",
  styles: "align-items:center;border:1px solid transparent;display:flex;justify-content:center;position:relative;width:100%;height:100%;&.vertical{justify-content:flex-start;}"
} : {
  name: "1gqu14n",
  styles: "align-items:center;border:1px solid transparent;display:flex;justify-content:center;position:relative;width:100%;height:100%;&.vertical{justify-content:flex-start;}",
  toString: Tn
});
Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh874"
} : {
  target: "e5foh874",
  label: "Item"
})();

var Ln = Vt(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: scale(1.4);\n  }\n  to {\n    transform: scale(1);\n  }\n"]))),
    Dn = Vt(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"]))),
    Vn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh873"
} : {
  target: "e5foh873",
  label: "CircleWrapper"
})("production" === process.env.NODE_ENV ? {
  name: "15e9q2n",
  styles: "align-items:center;display:flex;flex-direction:column;justify-content:center;width:5em"
} : {
  name: "15e9q2n",
  styles: "align-items:center;display:flex;flex-direction:column;justify-content:center;width:5em",
  toString: Tn
}),
    In = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh872"
} : {
  target: "e5foh872",
  label: "Circle"
})("border-radius:50%;cursor:pointer;height:", function (e) {
  return e.dimension;
}, "px;width:", function (e) {
  return e.dimension;
}, "px;&.active{&.using-icon{}&:not(.using-icon){transform:scale(1.25);}&::after{border-radius:50%;content:'';display:block;height:", function (e) {
  return e.dimension ? Math.round(.75 * e.dimension) : 20;
}, "px;width:", function (e) {
  return e.dimension ? Math.round(.75 * e.dimension) : 20;
}, "px;left:50%;position:absolute;top:50%;transform:translateY(-50%) translateX(-50%);z-index:-1;}}&:not(.using-icon){background:", function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, ";&.active{&::after{background:", function (e) {
  return e.theme.secondary;
}, ";}}&.in-active{animation:", Ln, " 0.1s ease-in;}}&.using-icon{background:#fff;display:flex;align-items:center;justify-content:center;transform:scale(1.25);img{max-width:90%;max-height:90%;}}"),
    jn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh871"
} : {
  target: "e5foh871",
  label: "TimelineTitleContainer"
})("production" === process.env.NODE_ENV ? {
  name: "1lrpu6z",
  styles: "display:flex;align-items:center;justify-content:flex-start;&.vertical{margin-bottom:1em;}&.horizontal{position:absolute;top:0;}"
} : {
  name: "1lrpu6z",
  styles: "display:flex;align-items:center;justify-content:flex-start;&.vertical{margin-bottom:1em;}&.horizontal{position:absolute;top:0;}",
  toString: Tn
}),
    Rn = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e5foh870"
} : {
  target: "e5foh870",
  label: "TimelineContentContainer"
})("align-items:flex-start;animation:", Dn, " 0.25s ease-in;&.horizontal{min-width:400px;}&.vertical{width:calc(100% - 5em);margin-left:auto;flex-direction:column;}"),
    $n = function $n(e) {
  var n = e.active,
      i = e.autoScroll,
      a = e.cardDetailedText,
      s = e.cardSubtitle,
      l = e.cardTitle,
      u = e.url,
      h = e.id,
      g = e.media,
      v = e.onClick,
      y = e.onElapsed,
      b = e.slideShowRunning,
      E = e.theme,
      w = e.title,
      N = e.wrapperId,
      x = e.customContent,
      k = e.hasFocus,
      O = e.iconChild,
      C = c(null),
      _ = c(null),
      S = c(null),
      T = o(p),
      A = T.mode,
      L = T.cardPositionHorizontal,
      D = T.timelineCircleDimension,
      V = T.disableClickOnCircle;

  d(function () {
    if (n) {
      var e = C.current,
          t = _.current;

      if (e && t) {
        var r = e.offsetLeft,
            o = t.offsetLeft;
        i({
          pointOffset: r + o,
          pointWidth: e.clientWidth
        });
      }
    }
  }, [n, i, A]);
  var I = f(function () {}, []),
      j = r(function () {
    return null == A ? void 0 : A.toLowerCase();
  }, [A]),
      R = r(function () {
    return nn("timeline-horz-card-wrapper", j, "TOP" === L ? "bottom" : "top");
  }, [A, L]),
      $ = r(function () {
    return nn(j, L);
  }, []),
      M = r(function () {
    return nn("timeline-circle", {
      "using-icon": !!O
    }, j, n ? "active" : "in-active");
  }, [n]),
      P = r(function () {
    return t.createElement(Rn, {
      className: R,
      ref: S
    }, t.createElement(Cn, {
      content: s,
      active: n,
      title: l,
      url: u,
      detailedText: a,
      onShowMore: I,
      theme: E,
      slideShowActive: b,
      media: g,
      onElapsed: y,
      id: h,
      customContent: x,
      hasFocus: k
    }));
  }, [n]);
  return t.createElement(An, {
    ref: _,
    className: j,
    "data-testid": "timeline-item"
  }, n && function () {
    var e = document.getElementById(N);
    if (e) return m.createPortal(P, e);
  }(), t.createElement(Vn, null, t.createElement(In, {
    className: M,
    onClick: function onClick() {
      V || !v || b || v(h);
    },
    ref: C,
    "data-testid": "timeline-circle",
    theme: E,
    "aria-label": w,
    dimension: D
  }, O || null)), t.createElement(jn, {
    className: $,
    "data-testid": "timeline-title"
  }, t.createElement(Sn, {
    title: w,
    active: n,
    theme: E
  })));
};

var Mn = Gt("ul", "production" === process.env.NODE_ENV ? {
  target: "e10s9yks1"
} : {
  target: "e10s9yks1",
  label: "TimelineHorizontalWrapper"
})("production" === process.env.NODE_ENV ? {
  name: "122q14q",
  styles: "display:flex;list-style:none;margin:0;width:100%;&.vertical{flex-direction:column;}&.horizontal{flex-direction:row;}"
} : {
  name: "122q14q",
  styles: "display:flex;list-style:none;margin:0;width:100%;&.vertical{flex-direction:column;}&.horizontal{flex-direction:row;}",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
}),
    Pn = Gt("li", "production" === process.env.NODE_ENV ? {
  target: "e10s9yks0"
} : {
  target: "e10s9yks0",
  label: "TimelineItemWrapper"
})("width:", function (e) {
  return e.width;
}, "px;visibility:hidden;display:flex;align-items:center;justify-content:center;height:100px;flex-direction:column;&.vertical{margin-bottom:2rem;width:100%;}&.visible{visibility:visible;}"),
    zn = function zn(e) {
  var n = e.items,
      i = e.handleItemClick,
      a = e.autoScroll,
      s = e.wrapperId,
      l = e.theme,
      c = e.slideShowRunning,
      u = e.onElapsed,
      d = e.contentDetailsChildren,
      f = e.hasFocus,
      m = e.iconChildren,
      h = o(p),
      g = h.mode;
  void 0 === g && (g = "HORIZONTAL");
  var v = h.itemWidth;
  void 0 === v && (v = 200);
  var y = h.cardHeight,
      b = r(function () {
    return nn(g.toLowerCase(), "timeline-horizontal-container");
  }, [g]),
      E = t.Children.toArray(m);
  return t.createElement(Mn, {
    className: b,
    "data-testid": "timeline-collection"
  }, n.map(function (e, n) {
    return t.createElement(Pn, {
      key: e.id,
      width: v,
      className: nn(e.visible ? "visible" : "", "timeline-horz-item-container")
    }, t.createElement($n, Object.assign({}, e, {
      onClick: i,
      autoScroll: a,
      mode: g,
      wrapperId: s,
      theme: l,
      slideShowRunning: c,
      cardHeight: y,
      onElapsed: u,
      customContent: d ? d[n] : null,
      hasFocus: f,
      iconChild: E[n]
    })));
  }));
};

function Wn() {
  return e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "prefix__feather prefix__feather-menu"
  }, e.createElement("path", {
    d: "M3 12h18M3 6h18M3 18h18"
  }));
}

function Hn() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Fn,
    qn = Vt(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  from {\n    width: 30px;\n    height: 30px;\n  }\n  \n  to: {\n    width: 200px;\n    height: 50%;\n  }\n  "]))),
    Bn = Vt(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from {\n    width: 200px;\n    height: 50%;\n  }\n  \n  to: {\n    width: 30px;\n    height: 30px;\n  }\n"]))),
    Un = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w6"
} : {
  target: "e3ufu3w6",
  label: "OutlineWrapper"
})("animation:", function (e) {
  return e.open ? qn : Bn;
}, ";animation-duration:0.2s;animation-timing-function:ease-in;background:rgba(255, 255, 255, 0.98);border:1px solid ", function (e) {
  return e.open ? "#f5f5f5" : "none";
}, ";height:50%;position:absolute;top:1rem;width:100%;z-index:9000;", function (e) {
  return e.position === Fn.left ? "left: 1rem;" : "right: 3rem;";
}, ";", function (e) {
  return e.open ? "\n    width: 200px;\n    height: 50%;\n    box-shadow: 0 5px 10px 2px rgba(0,0,0,0.2);\n    overflow-y: auto;" : "width: 30px; height: 30px;";
}, ";"),
    Yn = Gt("aside", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w5"
} : {
  target: "e3ufu3w5",
  label: "OutlinePane"
})("production" === process.env.NODE_ENV ? {
  name: "uioci2",
  styles: "align-items:center;border-radius:4px;display:flex;justify-content:center"
} : {
  name: "uioci2",
  styles: "align-items:center;border-radius:4px;display:flex;justify-content:center",
  toString: Hn
}),
    Gn = Gt("button", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w4"
} : {
  target: "e3ufu3w4",
  label: "OutlineButton"
})("align-items:center;align-self:flex-end;background:#fff;border-radius:4px;border:0;box-shadow:", function (e) {
  return e.open ? "none" : "0 0 10px 2px rgba(0,0,0,0.2)";
}, ";cursor:pointer;display:flex;height:30px;justify-content:center;padding:0;width:30px;", function (e) {
  return e.position === Fn.left ? "margin-right: auto;" : "margin-left: auto;";
}, ";& svg{width:70%;height:70%;}& svg path{color:", function (e) {
  return e.theme.primary;
}, ";}"),
    Zn = Gt("ul", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w3"
} : {
  target: "e3ufu3w3",
  label: "List"
})("production" === process.env.NODE_ENV ? {
  name: "592b28",
  styles: "display:flex;flex-direction:column;height:100%;list-style:none;margin:0;overflow-y:auto;padding:0;width:80%"
} : {
  name: "592b28",
  styles: "display:flex;flex-direction:column;height:100%;list-style:none;margin:0;overflow-y:auto;padding:0;width:80%",
  toString: Hn
}),
    Xn = Gt("li", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w2"
} : {
  target: "e3ufu3w2",
  label: "ListItem"
})("production" === process.env.NODE_ENV ? {
  name: "1680msm",
  styles: "align-items:center;display:flex;font-size:0.9rem;justify-content:flex-start;margin:0.75rem 0;cursor:pointer;position:relative;&:not(:last-child)::after{content:'';display:block;width:100%;position:absolute;height:1px;background:#ddd;left:0;right:0;margin:0 auto;bottom:-50%;}"
} : {
  name: "1680msm",
  styles: "align-items:center;display:flex;font-size:0.9rem;justify-content:flex-start;margin:0.75rem 0;cursor:pointer;position:relative;&:not(:last-child)::after{content:'';display:block;width:100%;position:absolute;height:1px;background:#ddd;left:0;right:0;margin:0 auto;bottom:-50%;}",
  toString: Hn
}),
    Kn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w1"
} : {
  target: "e3ufu3w1",
  label: "ListItemName"
})("font-size:0.75rem;color:", function (e) {
  return e.selected ? e.theme.primary : "";
}, ";padding-left:0.25rem;&:hover{color:", function (e) {
  return e.theme.primary;
}, ";}"),
    Jn = Gt("span", "production" === process.env.NODE_ENV ? {
  target: "e3ufu3w0"
} : {
  target: "e3ufu3w0",
  label: "ListItemBullet"
})("align-items:center;display:flex;justify-content:center;margin-right:1rem;position:relative;&::after{content:'';display:block;position:absolute;width:8px;height:8px;border-radius:50%;background:", function (e) {
  return e.selected ? "".concat(e.theme.secondary) : "".concat(e.theme.primary);
}, ";left:0;margin:0 auto;border:", function (e) {
  return e.selected ? "2px solid ".concat(e.theme.secondary) : "2px solid ".concat(e.theme.primary);
}, ";}");

function Qn() {
  return e.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "prefix__feather prefix__feather-x"
  }, e.createElement("path", {
    d: "M18 6L6 18M6 6l12 12"
  }));
}

!function (e) {
  e[e.left = 0] = "left", e[e.right = 1] = "right";
}(Fn || (Fn = {}));

var er = function er(e) {
  var i = e.items;
  void 0 === i && (i = []);
  var o = e.onSelect,
      a = e.theme,
      s = e.mode,
      l = n(!1),
      c = l[0],
      u = l[1],
      m = n([]),
      p = m[0],
      h = m[1],
      g = f(function () {
    return u(function (e) {
      return !e;
    });
  }, []),
      v = n(!1),
      y = v[0],
      b = v[1],
      E = r(function () {
    return "VERTICAL" === s ? Fn.left : "VERTICAL_ALTERNATING" === s ? Fn.right : Fn.left;
  }, [s]);
  d(function () {
    h(i.map(function (e) {
      return Object.assign({}, e, {
        selected: !1
      });
    }));
  }, [i.length]), d(function () {
    c ? setTimeout(function () {
      b(c);
    }, 300) : b(c);
  }, [c]);
  var w = f(function (e, t) {
    h(function (e) {
      return e.map(function (e) {
        return Object.assign({}, e, {
          selected: e.id === t
        });
      });
    }), o && o(e);
  }, []);
  return t.createElement(Un, {
    position: E,
    open: c
  }, t.createElement(Gn, {
    onClick: g,
    theme: a,
    open: c,
    position: E
  }, c ? t.createElement(Qn, null) : t.createElement(Wn, null)), t.createElement(Yn, {
    open: c
  }, y && t.createElement(Zn, null, p.map(function (e, n) {
    return t.createElement(Xn, {
      key: e.id,
      onClick: function onClick() {
        return w(n, e.id);
      }
    }, t.createElement(Jn, {
      theme: a,
      selected: e.selected
    }), t.createElement(Kn, {
      theme: a,
      selected: e.selected
    }, e.name));
  }))));
};

function tr() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var nr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk5"
} : {
  target: "eecm4uk5",
  label: "TimelineVerticalWrapper"
})("production" === process.env.NODE_ENV ? {
  name: "1ls5r8i",
  styles: "display:flex;flex-direction:column;width:100%;padding:1em;outline:0"
} : {
  name: "1ls5r8i",
  styles: "display:flex;flex-direction:column;width:100%;padding:1em;outline:0",
  toString: tr
}),
    rr = Vt(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    visibility: hidden;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n"]))),
    ir = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk4"
} : {
  target: "eecm4uk4",
  label: "VerticalItemWrapper"
})("production" === process.env.NODE_ENV ? {
  name: "gfz2d8",
  styles: "display:flex;position:relative;visibility:hidden;width:100%;align-items:stretch;&.left{margin-right:auto;}&.right{margin-left:auto;}&.visible{visibility:visible;}"
} : {
  name: "gfz2d8",
  styles: "display:flex;position:relative;visibility:hidden;width:100%;align-items:stretch;&.left{margin-right:auto;}&.right{margin-left:auto;}&.visible{visibility:visible;}",
  toString: tr
}),
    or = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk3"
} : {
  target: "eecm4uk3",
  label: "VerticalCircleWrapper"
})("align-items:center;display:flex;justify-content:center;position:relative;width:10%;&.left{order:2;}&.right{order:1;}&::after{background:", function (e) {
  return e.bg;
}, ";content:'';display:block;height:100%;left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;width:", function (e) {
  return e.width ? "".concat(e.width, "px") : "4px";
}, ";z-index:0;}"),
    ar = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk2"
} : {
  target: "eecm4uk2",
  label: "TimelineCardContentWrapper"
})("visibility:hidden;position:relative;display:flex;align-items:center;", function (e) {
  return e.alternateCards ? "width: 50%;" : e.noTitle ? "width: 90%;" : "width: 75%;";
}, " ", function (e) {
  return e.flip ? "\n        justify-content: flex-end;\n        &.left {\n          order: 3;\n        }\n        &.right {\n          order: 1;\n        }\n      " : "\n        &.left {\n          order: 1;\n          justify-content: flex-end;\n        }\n        &.right {\n          order: 3;\n          justify-content: flex-start;\n        }\n      ";
}, " &.visible{visibility:visible;animation:", rr, " 0.25s ease-in;}"),
    sr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk1"
} : {
  target: "eecm4uk1",
  label: "VerticalCircleContainer"
})("production" === process.env.NODE_ENV ? {
  name: "179t5g5",
  styles: "position:relative;z-index:1"
} : {
  name: "179t5g5",
  styles: "position:relative;z-index:1",
  toString: tr
}),
    lr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "eecm4uk0"
} : {
  target: "eecm4uk0",
  label: "TimelineTitleWrapper"
})("align-items:center;display:", function (e) {
  return e.hide && "VERTICAL" === e.mode ? "none" : "flex";
}, ";", function (e) {
  return e.alternateCards ? "width: 50%" : "width: 15%";
}, ";&.left{justify-content:", function (e) {
  return e.flip ? "flex-end" : "flex-start";
}, ";order:", function (e) {
  return e.flip && "VERTICAL_ALTERNATING" === e.mode ? "1" : "3";
}, ";}&.right{", function (e) {
  return e.flip ? "\n      order: 3;\n      justify-content: flex-start;" : "order: 1;\n    justify-content: flex-end;";
}, ";}"),
    cr = function cr(e) {
  var n = e.className,
      i = e.id,
      o = e.onClick,
      a = e.active,
      s = e.onActive,
      l = e.theme,
      u = e.alternateCards,
      f = e.slideShowRunning,
      m = e.iconChild,
      p = e.timelineCircleDimension,
      h = e.lineWidth,
      g = e.disableClickOnCircle,
      v = c(null);
  d(function () {
    if (a) {
      var e = v.current;
      e && s(e.offsetTop);
    }
  }, [a]);
  var y = r(function () {
    return nn({
      active: a,
      "using-icon": !!m
    });
  }, [a, m]),
      b = r(function () {
    return !g && {
      onClick: function onClick(e) {
        e.stopPropagation(), i && o && !f && o(i);
      }
    };
  }, []);
  return t.createElement(or, {
    width: h,
    alternateCards: u,
    bg: l && l.primary,
    className: n,
    "data-testid": "tree-leaf",
    role: "button"
  }, t.createElement(sr, Object.assign({}, {
    className: "".concat(n, " timeline-vertical-circle")
  }, b, {
    ref: v,
    role: "button",
    "data-testid": "tree-leaf-click",
    "aria-label": "select timeline"
  }), t.createElement(In, {
    className: y,
    theme: l,
    dimension: p
  }, m || null)));
},
    ur = function ur(e) {
  var n = c(null),
      i = e.active,
      a = e.alternateCards,
      s = e.cardDetailedText,
      l = e.cardSubtitle,
      u = e.cardTitle,
      d = e.url,
      m = e.className,
      h = e.contentDetailsChildren,
      g = e.iconChild,
      v = e.hasFocus,
      y = e.id,
      b = e.media,
      E = e.onActive,
      w = e.onClick,
      N = e.onElapsed,
      x = e.slideShowRunning,
      k = e.theme,
      O = e.title,
      C = e.visible,
      _ = function _(e) {
    if (n.current) {
      var t = n.current,
          r = t.offsetTop,
          i = t.clientHeight;
      E(r + e, r, i);
    }
  },
      S = o(p),
      T = S.cardHeight,
      A = S.mode,
      L = S.flipLayout,
      D = S.timelineCircleDimension,
      V = S.lineWidth,
      I = S.disableClickOnCircle,
      j = f(function () {
    setTimeout(function () {
      _(0);
    }, 100);
  }, []),
      R = r(function () {
    return t.createElement(lr, {
      className: m,
      alternateCards: a,
      mode: A,
      hide: !O,
      flip: L
    }, t.createElement(Sn, {
      title: O,
      active: i,
      theme: k,
      align: L ? "left" : "right"
    }));
  }, [i]),
      $ = r(function () {
    var e;
    return nn(((e = {})[m] = !0, e), "vertical-item-row", C ? "visible" : "");
  }, []),
      M = r(function () {
    var e,
        n = nn("card-content-wrapper", C ? "visible" : "", ((e = {})[m] = !0, e));
    return t.createElement(ar, {
      className: n,
      alternateCards: a,
      noTitle: !O,
      flip: L
    }, t.createElement(Cn, {
      active: i,
      branchDir: m,
      content: l,
      customContent: h,
      detailedText: s,
      hasFocus: v,
      id: y,
      media: b,
      onClick: w,
      onElapsed: N,
      onShowMore: j,
      slideShowActive: x,
      theme: k,
      title: u,
      url: d,
      flip: L
    }));
  }, [v, x, i]),
      P = r(function () {
    return t.createElement(cr, {
      active: i,
      alternateCards: a,
      className: m,
      id: y,
      mode: A,
      onActive: _,
      onClick: w,
      slideShowRunning: x,
      iconChild: g,
      theme: k,
      timelineCircleDimension: D,
      lineWidth: V,
      disableClickOnCircle: I
    });
  }, [x, i]);

  return t.createElement(ir, {
    alternateCards: a,
    cardHeight: T,
    className: $,
    "data-testid": "vertical-item-row",
    key: y,
    ref: n,
    role: "listitem"
  }, R, M, P);
},
    dr = function dr(e) {
  var n = e.alternateCards;
  void 0 === n && (n = !0);
  var i = e.autoScroll,
      o = e.contentDetailsChildren,
      a = e.enableOutline,
      s = e.hasFocus,
      l = e.iconChildren,
      c = e.items,
      u = e.mode,
      d = e.onClick,
      m = e.onElapsed,
      p = e.onOutlineSelection,
      h = e.slideShowRunning,
      g = e.theme,
      v = f(function (e, t, n) {
    i({
      pointOffset: e,
      contentHeight: n,
      contentOffset: t
    });
  }, []),
      y = f(function () {}, []),
      b = r(function () {
    return c.map(function (e) {
      return {
        id: Math.random().toString(16).slice(2),
        name: e.title
      };
    });
  }, [c.length]);
  return t.createElement(nr, {
    "data-testid": "tree-main",
    role: "list"
  }, a && t.createElement(er, {
    theme: g,
    mode: u,
    items: b,
    onSelect: p
  }), c.map(function (e, r) {
    var i = "";
    i = n && r % 2 == 0 ? "left" : "right";
    var a = o && o[r] || null,
        c = l && l[r] || null;
    return t.createElement(ur, Object.assign({}, e, {
      alternateCards: n,
      className: i,
      contentDetailsChildren: a,
      iconChild: c,
      hasFocus: s,
      index: r,
      key: e.id,
      onActive: v,
      onClick: d,
      onElapsed: m,
      onShowMore: y,
      slideShowRunning: h,
      theme: g
    }));
  }));
};

function fr() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var mr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz5"
} : {
  target: "e1gmwefz5",
  label: "Wrapper"
})("display:flex;flex-direction:column;height:100%;&:focus{outline:0;}overflow:hidden;position:relative;user-select:none;width:100%;", function (e) {
  return "TOP" === e.cardPositionHorizontal ? "\n    & > div:nth-of-type(1) {\n      order: 2;\n    }\n    & > div:nth-of-type(2) {\n      order: 1; \n    }\n    & > div:nth-of-type(3) {\n      order: 3;\n    }\n  " : "";
}, ";&.horizontal{justify-content:flex-start;}&.js-focus-visible :focus:not(.focus-visible){outline:0;}&.js-focus-visible .focus-visible{outline:2px solid #528deb;}"),
    pr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz4"
} : {
  target: "e1gmwefz4",
  label: "TimelineMainWrapper"
})("align-items:flex-start;display:flex;justify-content:center;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;", function (e) {
  return "HORIZONTAL" === e.mode ? "position: relative" : "";
}, ";scroll-behavior:smooth;scrollbar-color:", function (e) {
  return e.theme.primary;
}, " default;scrollbar-width:thin;width:100%;&::-webkit-scrollbar{width:0.5em;height:0;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0, 0, 0, 0.2);}&::-webkit-scrollbar-thumb{background-color:", function (e) {
  return e.theme.primary;
}, ";outline:1px solid ", function (e) {
  return e.theme.primary;
}, ";}&.horizontal{height:6rem;}padding:", function (e) {
  return e.scrollable ? "" : "0 1rem 0";
}, ";"),
    hr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz3"
} : {
  target: "e1gmwefz3",
  label: "TimelineMain"
})("production" === process.env.NODE_ENV ? {
  name: "1k315ys",
  styles: "align-items:center;bottom:0;display:flex;left:0;position:absolute;transition:all 0.2s ease;&.vertical{align-items:flex-start;height:100%;justify-content:flex-start;width:100%;}"
} : {
  name: "1k315ys",
  styles: "align-items:center;bottom:0;display:flex;left:0;position:absolute;transition:all 0.2s ease;&.vertical{align-items:flex-start;height:100%;justify-content:flex-start;width:100%;}",
  toString: fr
}),
    gr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz2"
} : {
  target: "e1gmwefz2",
  label: "Outline"
})("background:", function (e) {
  return e.color;
}, ";height:", function (e) {
  return "".concat(e.height, "px");
}, ";left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;width:100%;"),
    vr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz1"
} : {
  target: "e1gmwefz1",
  label: "TimelineControlContainer"
})("align-items:center;display:flex;justify-content:center;min-height:3rem;filter:", function (e) {
  return e.active ? "opacity(1);" : "opacity(0.9);";
}, ";&.hide{visibility:hidden;}&.show{visibility:visible;}"),
    yr = Gt("div", "production" === process.env.NODE_ENV ? {
  target: "e1gmwefz0"
} : {
  target: "e1gmwefz0",
  label: "TimelineContentRender"
})("production" === process.env.NODE_ENV ? {
  name: "i5uwaq",
  styles: "margin-left:auto;margin-right:auto;width:98%;display:flex;align-items:center;justify-content:center"
} : {
  name: "i5uwaq",
  styles: "margin-left:auto;margin-right:auto;width:98%;display:flex;align-items:center;justify-content:center",
  toString: fr
}),
    br = function br(e) {
  var i = e.activeTimelineItem,
      a = e.contentDetailsChildren,
      s = e.iconChildren,
      l = e.items;
  void 0 === l && (l = []);
  var u = e.onFirst,
      m = e.onLast,
      h = e.onNext,
      v = e.onPrevious,
      y = e.onRestartSlideshow,
      b = e.onTimelineUpdated,
      E = e.onItemSelected,
      w = e.onOutlineSelection,
      N = e.slideShowEnabled,
      x = e.slideShowRunning,
      k = e.theme,
      O = o(p),
      C = O.scrollable;
  void 0 === C && (C = !0);
  var _ = O.mode;
  void 0 === _ && (_ = "HORIZONTAL");
  var S = O.hideControls,
      T = O.itemWidth;
  void 0 === T && (T = 200);

  var A = O.disableNavOnKey,
      L = O.cardPositionHorizontal,
      D = O.onScrollEnd,
      V = O.enableOutline,
      I = O.lineWidth,
      j = g(_, T),
      R = j[0],
      $ = j[1],
      M = c(null),
      P = n(!1),
      z = P[0],
      W = P[1],
      H = c(null),
      F = r(function () {
    if (!x) {
      if ("boolean" == typeof C) return C;
      if ("object" == typeof C && C.scrollbar) return C.scrollbar;
    }
  }, [x, C]),
      q = c("react-chrono-timeline"),
      B = f(function () {
    return z && h();
  }, [z, h]),
      U = f(function () {
    return z && v();
  }, [z, v]),
      Y = f(function () {
    return z && u();
  }, [z, u]),
      G = f(function () {
    return z && m();
  }, [z, m]),
      Z = function Z(e, t) {
    if (e) {
      for (var n = 0; n < l.length; n++) {
        if (l[n].id === e) {
          t && n < l.length - 1 ? b(n + 1) : b(n);
          break;
        }
      }

      var r = l.find(function (t) {
        return t.id === e;
      });
      r && E && E(r);
    }
  };

  d(function () {
    l.length && l[i] && E && E(l[i]);
  }, [i]);
  var X = f(function (e) {
    var t = H.current;
    t && $(t, e);
  }, [$]);
  return d(function () {
    var e = H.current;
    e && ("HORIZONTAL" === _ ? e.scrollLeft = R : e.scrollTop = R);
  }, [R]), d(function () {
    setTimeout(function () {
      var e = H.current;

      if (e) {
        var t = e.querySelectorAll(".vertical-item-row");
        Array.from(t).forEach(function (e) {
          M.current && M.current.observe(e);
        });
      }
    }, 0);

    var e = function e(_e2, t) {
      _e2.querySelectorAll("img,video").forEach(function (e) {
        return e.style.visibility = "hide" === t ? "hidden" : "visible";
      });
    };

    return "HORIZONTAL" !== _ && (M.current = new IntersectionObserver(function (t) {
      t.forEach(function (t) {
        var n = t.target;
        t.isIntersecting ? e(n, "show") : (e(n, "hide"), n.querySelectorAll("iframe").forEach(function (e) {
          var t;
          null === (t = e.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
        }));
      });
    }, {
      root: H.current,
      threshold: 0
    })), function () {
      M.current && M.current.disconnect();
    };
  }, []), t.createElement(mr, {
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      var t;
      !A && !x && (t = e.key, "HORIZONTAL" === _ && "ArrowRight" === t || ("VERTICAL" === _ || "VERTICAL_ALTERNATING" === _) && "ArrowDown" === t ? B() : "HORIZONTAL" === _ && "ArrowLeft" === t || ("VERTICAL" === _ || "VERTICAL_ALTERNATING" === _) && "ArrowUp" === t ? U() : "Home" === t ? Y() : "End" === t && G());
    },
    className: "".concat(_.toLowerCase(), " js-focus-visible focus-visible"),
    cardPositionHorizontal: L,
    onMouseDownCapture: function onMouseDownCapture() {
      W(!0);
    }
  }, t.createElement(pr, {
    ref: H,
    scrollable: F,
    className: "".concat(_.toLowerCase(), " timeline-main-wrapper"),
    id: "timeline-main-wrapper",
    theme: k,
    mode: _,
    onScroll: function onScroll(e) {
      var t = e.target,
          n = 0;
      "VERTICAL" === _ || "VERTICAL_ALTERNATING" === _ ? (n = t.scrollTop + t.clientHeight, t.scrollHeight - n < 1 && D && D()) : (n = t.scrollLeft + t.offsetWidth, t.scrollWidth === n && D && D());
    }
  }, "VERTICAL_ALTERNATING" === _ ? t.createElement(dr, {
    activeTimelineItem: i,
    autoScroll: X,
    contentDetailsChildren: a,
    hasFocus: z,
    iconChildren: s,
    items: l,
    mode: _,
    onClick: Z,
    onElapsed: function onElapsed(e) {
      return Z(e, !0);
    },
    onOutlineSelection: w,
    slideShowRunning: x,
    theme: k,
    enableOutline: V
  }) : null, "HORIZONTAL" === _ ? t.createElement(hr, {
    className: _.toLowerCase()
  }, t.createElement(gr, {
    color: k && k.primary,
    height: I
  }), t.createElement(zn, {
    autoScroll: X,
    contentDetailsChildren: a,
    handleItemClick: Z,
    hasFocus: z,
    iconChildren: s,
    items: l,
    mode: _,
    onElapsed: function onElapsed(e) {
      return Z(e, !0);
    },
    slideShowRunning: x,
    theme: k,
    wrapperId: q.current
  })) : null, "VERTICAL" === _ ? t.createElement(dr, {
    activeTimelineItem: i,
    alternateCards: !1,
    autoScroll: X,
    contentDetailsChildren: a,
    hasFocus: z,
    iconChildren: s,
    items: l,
    mode: _,
    onClick: Z,
    onElapsed: function onElapsed(e) {
      return Z(e, !0);
    },
    onOutlineSelection: w,
    slideShowRunning: x,
    theme: k,
    enableOutline: V
  }) : null), !S && t.createElement(vr, {
    mode: _
  }, t.createElement(Qt, {
    disableLeft: 0 === i,
    disableRight: i === l.length - 1,
    id: q.current,
    onFirst: Y,
    onLast: G,
    onNext: B,
    onPrevious: U,
    onReplay: y,
    slideShowEnabled: N,
    slideShowRunning: x,
    theme: k
  })), t.createElement(yr, {
    id: q.current
  }));
},
    Er = t.Children.toArray,
    wr = function wr(e) {
  var r = e.allowDynamicUpdate;
  void 0 === r && (r = !1);
  var i = e.children,
      o = e.items,
      a = e.onScrollEnd,
      s = e.slideShow;
  void 0 === s && (s = !1);
  var l = e.theme,
      u = e.onItemSelected,
      m = e.activeItemIndex;
  void 0 === m && (m = 0);

  var p = n([]),
      g = p[0],
      v = p[1],
      y = c(),
      b = n(!1),
      E = b[0],
      w = b[1],
      N = n(m),
      x = N[0],
      k = N[1],
      O = Object.assign({
    primary: "#0f52ba",
    secondary: "#ffdf00",
    cardBgColor: "#fff",
    cardForeColor: "#000",
    titleColor: "#0f52ba"
  }, l),
      C = function C(e) {
    return e && e.length ? e.map(function (e, t) {
      return Object.assign({}, e, {
        id: Math.random().toString(16).slice(2),
        visible: !0,
        active: t === m
      });
    }) : Array.from({
      length: t.Children.toArray(i).filter(function (e) {
        return "chrono-icons" !== e.props.className;
      }).length
    }).map(function (e, t) {
      return {
        id: Math.random().toString(16).slice(2),
        visible: !0,
        active: t === m
      };
    });
  };

  d(function () {
    var e = null == o ? void 0 : o.filter(function (e) {
      return e;
    }),
        t = [];
    if (null == e ? void 0 : e.length) g.length && e.length > g.length ? t = function (e) {
      if (e) {
        var t = g.length;
        return e.map(function (e, n) {
          return Object.assign({}, e, {
            id: Math.random().toString(16).slice(2),
            visible: !0,
            active: n === t
          });
        });
      }

      return [];
    }(e) : e.length && (t = C(e)), t.length && (y.current = t, v(t));else {
      var n = C();
      v(n);
    }
  }, [JSON.stringify(r ? o : null)]);

  var _ = f(function (e) {
    v(function (t) {
      return t.map(function (t, n) {
        return Object.assign({}, t, {
          active: n === e
        });
      });
    }), k(e), o && o.length - 1 === e && w(!1);
  }, []),
      S = f(function () {
    w(!0), _(0);
  }, []),
      T = f(function (e) {
    e >= 0 && (k(e), _(e));
  }, [g.length]),
      A = Er(i).filter(function (e) {
    return "chrono-icons" === e.props.className;
  });

  return A.length && (A = A[0].props.children), t.createElement(h, Object.assign({}, e), t.createElement(br, {
    activeTimelineItem: x,
    contentDetailsChildren: Er(i).filter(function (e) {
      return "chrono-icons" !== e.props.className;
    }),
    iconChildren: A,
    items: g,
    onFirst: function onFirst() {
      k(0), _(0);
    },
    onLast: function onLast() {
      if (g.length) {
        var e = g.length - 1;
        k(e), _(e);
      }
    },
    onNext: function onNext() {
      if (g.length && x < g.length - 1) {
        var e = x + 1;
        _(e), k(e);
      }
    },
    onPrevious: function onPrevious() {
      if (x > 0) {
        var e = x - 1;
        _(e), k(e);
      }
    },
    onRestartSlideshow: S,
    onTimelineUpdated: _,
    slideShow: s,
    slideShowEnabled: s,
    slideShowRunning: E,
    theme: O,
    onScrollEnd: a,
    onItemSelected: u,
    onOutlineSelection: T
  }));
};

export { wr as Chrono };